// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + "0a94fdcdd889767cbfad" + ".css";
};